import React from "react"
import ReactDOM from 'react-dom/client'
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import { GoogleOAuthProvider } from "@react-oauth/google"
import "./i18n"
import { Provider } from "react-redux"

import store from "./store"

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || ""

const root = ReactDOM.createRoot(document.getElementById('root')!)

root.render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId={googleClientId}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </GoogleOAuthProvider>
  </Provider>
)

serviceWorker.unregister()
